import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-firstlogin',
    templateUrl: './change-password-firstlogin.component.html',
    styleUrls: ['./change-password-firstlogin.component.css'],
    standalone: false
})
export class ChangePasswordFirstloginComponent implements OnInit {

  serverErrorMessages: string;
  successMessage: string;
  form = new FormGroup({
    userName: new FormControl('', [Validators.required]),
    newPassword: new FormControl('', [Validators.required]),
    oldPassword: new FormControl('', [Validators.required]),
    confirmDate : new FormControl(new Date().toUTCString(), []),
  });
  loading: boolean = true;
  constructor(private loginservice: LoginService, private router: Router) { }

  ngOnInit(): void {
    if(this.loginservice.isLoggedIn()){
     //console.log("Already logged in! Log Out first");
      this.loginservice.getUserProfile().subscribe(
        res => {
          this.router.navigateByUrl('/home');
        },
        err => {
         //console.log('Did not get user', err);
        });
    }
    this.loading = false;
  }

  onSubmit(){
   console.log(this.form.value)
    this.loginservice.changePasswordFirstLogin(this.form.value).subscribe(
      res=>{
       //console.log('success', res)
        alert('Password changed! Please login with your new password')
        this.router.navigateByUrl('/signin')
      },
      err=>{
       //console.log('error', err)
      }
    )
  }

}
